export default "__VITE_ASSET__CsKESMYM__"